import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: "/home",
    name: "Home",
    component: () => {
      return import("@/layouts/adminPanel");
    },
    meta: { requiresAuth: true },
    children: [
      {
        path: "",
        name: "Home",
        component: () => {
          return import("../views/Dashboard");
        },
        meta: { requiresAuth: true },

      },
      {
        path: "/admin",
        name: "Home",
        component: () => {
          return import("../views/Home");
        },
        meta: { requiresAuth: true },

      },
         {
        path: "/partner-university",
        name: "PartnerUniver",
        component: () => {
          return import("../views/PartnerUniver.vue");
        },
        meta: { requiresAuth: true },

      },
      {
        path: "/news",
        name: "News",
        component: () => {
          return import("../views/News");
        },
        meta: { requiresAuth: true },
      },
      {
        path: "/news-images",
        name: "NewsImages",
        component: () => {
          return import("../views/newsImage");
        },
        meta: { requiresAuth: true },
      },
      {
        path: "/menu",
        name: "Menu",
        component: () => {
          return import("../views/menuNavbar");
        },
        meta: { requiresAuth: true },
      },
      {
        path: "/carousel",
        name: "Carousel",
        component: () => {
          return import("../views/Carousel");
        },
        meta: { requiresAuth: true },
      },
      {
        path: "/rahbariyat",
        name: "Rahbariyat",
        component: () => {
          return import("../views/Rahbariyat");
        },
        meta: { requiresAuth: true },
      },
      {
        path: "/new-page",
        name: "NewPage",
        component: () => {
          return import("../views/AddPage");
        },
        meta: { requiresAuth: true },
      },
      {
        path: "/new-page-images",
        name: "NewPagesImages",
        component: () => {
          return import("../views/PagesImage");
        },
        meta: { requiresAuth: true },
      },
      {
        path: "/fotos",
        name: "Fotos",
        component: () => {
          return import("../views/Fotos.vue");
        },
        meta: { requiresAuth: true },
      },
      {
        path: "/videos",
        name: "Videos",
        component: () => {
          return import("../views/Videos.vue");
        },
        meta: { requiresAuth: true },
      },
      {
        path: "/new-employee",
        name: "NewEmployee",
        component: () => {
          return import("../views/AddEmployee");
        },
        meta: { requiresAuth: true },
      },
      {
        path: "/center",
        name: "Center",
        component: () => {
          return import("../views/Center");
        },
        meta: { requiresAuth: true },
      },
      {
        path: "/addCategory",
        name: "addCategory",
        component: () => {
          return import("../views/AddCategory");
        },
        meta: { requiresAuth: true },
      },
      {
        path: "/talim-dasturi",
        name: "TalimDasturi",
        component: () => {
          return import("../views/TalimDasturi");
        },
        meta: { requiresAuth: true },
      },
      {
        path: "/our-service",
        name: "OurService",
        component: () => {
          return import("../views/OurService.vue");
        },
        meta: { requiresAuth: true },
      },
      {
        path: "/savol-javob",
        name: "SavolJavob",
        component: () => {
          return import("../views/FAQ");
        },
        meta: { requiresAuth: true },
      },
      {
        path: "/kurslar",
        name: "Kurslar",
        component: () => {
          return import("../views/Kurslar.vue");
        },
        meta: { requiresAuth: true },
      },
       {
        path: "/events",
        name: "Events",
        component: () => {
          return import("../views/Tadbirlar.vue");
        },
        meta: { requiresAuth: true },
      },
      {
        path: "/interactive",
        name: "Interactive",
        component: () => {
          return import("../views/Interactive");
        },
        meta: { requiresAuth: true },
      },
      {
        path: "/useful-link",
        name: "UsefulLink",
        component: () => {
          return import("../views/UsefulLink");
        },
        meta: { requiresAuth: true },
      },
      {
        path: "/web-tizimlar",
        name: "WebTizimlar",
        component: () => {
          return import("../views/RTTM");
        },
        meta: { requiresAuth: true },
      },
        {
        path: "/ilmiy-tadqiqot",
        name: "IlmiyTadqiqot",
        component: () => {
          return import("../views/IlmiyTadqiqot.vue");
        },
        meta: { requiresAuth: true },
      },
      {
        path: "/amaliyotlar",
        name: "Amaliyotlar",
        component: () => {
          return import("../views/Amaliyot.vue");
        },
        meta: { requiresAuth: true },
      },
       {
        path: "/missiyamiz",
        name: "Missiyamiz",
        component: () => {
          return import("../views/Missiya.vue");
        },
        meta: { requiresAuth: true },
      },
    ],
  },
  {
    path: "/login",
    name: "Login",
    component: () => {
      return import("@/layouts/loginPage");
    },
    children: [
      {
        path: "",
        name: "Login",
        component: () => {
          return import("../views/Login");
        },
      },
    ],
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.requiresAuth)) {
    const isLoggedIn = localStorage.getItem("access_token");
    if (isLoggedIn) {
      next();
      return;
    } else {
      next("/login");
    }
  } else {
    next();
  }
});

export default router;
